import { ITouchEvent } from "@vnxjs/components"
import { createContext } from "react"

interface SearchContextValue {
  onCancel?(event: ITouchEvent): void
}

const SearchContext = createContext<SearchContextValue>({})

export default SearchContext
